import { createReducer, on } from '@ngrx/store';
import { DEFAULT_USER_PREFERENCES_STATE } from 'features/user-preferences/user-preferences.constants';
import {
  CustomFieldsPreferencesActions,
  DashboardPreferencesActions,
  ReportsPreferencesActions,
  TablePreferencesActions,
} from 'features/user-preferences/store/user-preferences.actions';
import { omit } from 'lodash-es';

export const tablePreferencesReducer = createReducer(
  DEFAULT_USER_PREFERENCES_STATE.tables,
  on(TablePreferencesActions.setUserTableConfiguration, (tables, { tableKey, tableConfiguration }) => ({
    ...tables,
    [tableKey]: tableConfiguration,
  })),
  on(TablePreferencesActions.resetUserTableConfiguration, (tables, { tableKey }) => ({
    ...tables,
    [tableKey]: DEFAULT_USER_PREFERENCES_STATE.tables[tableKey],
  })),
  on(TablePreferencesActions.setTableConfigurationFilters, (tables, { tableKey, filters }) => ({
    ...tables,
    [tableKey]: {
      ...tables[tableKey],
      filters,
    },
  })),
  on(TablePreferencesActions.resetTableConfigurationFilters, (tables, { tableKey }) => ({
    ...tables,
    [tableKey]: {
      ...tables[tableKey],
      filters: DEFAULT_USER_PREFERENCES_STATE.tables[tableKey].filters,
    },
  })),
  on(TablePreferencesActions.setTableOrder, (tables, { tableKey, sort }) => ({
    ...tables,
    [tableKey]: {
      ...tables[tableKey],
      sort,
    },
  })),
  on(TablePreferencesActions.resetTableOrder, (tables, { tableKey }) => ({
    ...tables,
    [tableKey]: {
      ...tables[tableKey],
      sort: DEFAULT_USER_PREFERENCES_STATE.tables[tableKey].sort,
    },
  })),
);

export const customFieldsPreferencesReducer = createReducer(
  DEFAULT_USER_PREFERENCES_STATE.customFields,

  on(CustomFieldsPreferencesActions.setCustomFieldsState, (customFields, { customFieldsKey, customFieldsState }) => ({
    ...customFields,
    [customFieldsKey]: {
      ...customFields[customFieldsKey],
      ...customFieldsState,
    },
  })),
  on(CustomFieldsPreferencesActions.resetCustomFieldsState, (customFields, { customFieldsKey }) => ({
    ...customFields,
    [customFieldsKey]: {},
  })),
);

export const dashboardPreferencesReducer = createReducer(
  DEFAULT_USER_PREFERENCES_STATE.dashboard,
  on(
    DashboardPreferencesActions.initializeDashboardConfiguration,
    DashboardPreferencesActions.resetDashboardConfiguration,
    (dashboard, { dashboardName, configuration }) => {
      return {
        ...dashboard,
        [dashboardName]: configuration,
      };
    },
  ),
  on(DashboardPreferencesActions.resetDashboardSmartFilters, (dashboard, { dashboardName, smartFilters }) => {
    return {
      ...dashboard,
      [dashboardName]: {
        ...dashboard[dashboardName],
        smartFilters,
      },
    };
  }),
  on(DashboardPreferencesActions.updateDashboardSmartFilters, (dashboard, { dashboardName, smartFilters }) => {
    return {
      ...dashboard,
      [dashboardName]: {
        ...dashboard[dashboardName],
        smartFilters: {
          ...dashboard[dashboardName].smartFilters,
          ...smartFilters,
        },
      },
    };
  }),
);

export const reportsPreferencesReducer = createReducer(
  DEFAULT_USER_PREFERENCES_STATE.reports,
  on(
    ReportsPreferencesActions.initializeReportsConfiguration,
    ReportsPreferencesActions.resetReportsConfiguration,
    (reports, { reportsName, configuration }) => {
      return {
        ...reports,
        [reportsName]: configuration,
      };
    },
  ),
  on(ReportsPreferencesActions.resetReportsSmartFilters, (reports, { reportsName, smartFilters }) => {
    return {
      ...reports,
      [reportsName]: {
        ...reports[reportsName],
        smartFilters,
      },
    };
  }),

  on(ReportsPreferencesActions.updateReportsSmartFilters, (reports, { reportsName, smartFilters }) => {
    return {
      ...reports,
      [reportsName]: {
        ...reports[reportsName],
        smartFilters: {
          ...reports[reportsName].smartFilters,
          ...smartFilters,
        },
      },
    };
  }),
  on(ReportsPreferencesActions.updateTableOrder, (reports, { reportsName, tableKey, tableOrder }) => {
    return {
      ...reports,
      [reportsName]: {
        ...reports[reportsName],
        tableOrders: {
          ...reports[reportsName].tableOrders,
          [tableKey]: tableOrder,
        },
      },
    };
  }),
  on(ReportsPreferencesActions.resetTableOrder, (reports, { reportsName, tableKey }) => {
    return {
      ...reports,
      [reportsName]: {
        ...reports[reportsName],
        tableOrders: omit(reports[reportsName].tableOrders, tableKey),
      },
    };
  }),
);
